var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIntershipduration(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 30,
    viewBox: "0 0 27 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.1568 4.20312H3.63982C2.94017 4.20469 2.26963 4.48332 1.77491 4.97805C1.28018 5.47277 1.00157 6.14331 1 6.84296V26.3599C1.00157 27.0595 1.28018 27.7301 1.77491 28.2248C2.26963 28.7195 2.94017 28.9982 3.63982 28.9997H23.1568C23.8564 28.9982 24.527 28.7195 25.0217 28.2248C25.5164 27.7301 25.795 27.0595 25.7966 26.3599V6.84296C25.795 6.14331 25.5164 5.47277 25.0217 4.97805C24.527 4.48332 23.8564 4.20469 23.1568 4.20312Z",
    stroke: "white",
    strokeWidth: 1.44,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.3093 12.9238H12.5974",
    stroke: "#BCBCBC",
    strokeWidth: 1.44,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.3093 18.3516H19.9237",
    stroke: "#BCBCBC",
    strokeWidth: 1.44,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.57202 1V6.81356",
    stroke: "#BCBCBC",
    strokeWidth: 1.44,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2246 1V6.81356",
    stroke: "#BCBCBC",
    strokeWidth: 1.44,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntershipduration);
export default __webpack_public_path__ + "static/media/intershipduration.82ff20f046e678963fa900a6bd356999.svg";
export { ForwardRef as ReactComponent };